export default __webpack_public_path__ + "static/media/Me3.48f4a910.png";